export default __webpack_public_path__ + "static/media/logo_txt.7e3c1be6.png";